// Texty kampaňové vrstvy (campaign.js) a ploch, které po dobu kampaně mluví
// o deštníku nad akční nabídkou. Klíč = `id` kampaně z manifestu `campaigns`.
// Číslo slevy (`claimPct`) je DATA manifestu; null = věta bez čísla.
import { NBSP } from '../../modules/money.js';

const pct = (n) => '−' + n + NBSP + '%';

export default {
  /** „Výprodej skladu až −30 %", bez čísla „Výprodej skladu" */
  clearance: (claimPct) => (claimPct ? 'Výprodej skladu až ' + pct(claimPct) : 'Výprodej skladu'),
  /** popisek nad cenou u zboží ve výprodeji skladu (detail) */
  clearancePrice: 'Výprodej skladu',
  octSale: {
    name: 'Říjnový výprodej',
    /** promo pruh: „ŘÍJNOVÝ VÝPRODEJ" + „ · výprodej skladu až −30 %" (mobil ≤ 45 znaků) */
    barStrong: 'ŘÍJNOVÝ VÝPRODEJ',
    barLead: (claimPct) => (claimPct ? ' · výprodej skladu až ' + pct(claimPct) : ' · právě běží'),
    barCta: 'Zobrazit výprodej',
    /** zóna akční nabídky na homepage (nadpis = `name`) */
    zoneEyebrow: (claimPct) =>
      claimPct ? 'Výprodej skladu až ' + pct(claimPct) + ' a další slevy' : 'Zlevněné zboží napříč sortimentem',
    zoneCta: 'Zobrazit celý výprodej',
    /** bento banner akční nabídky (nadpis = `name`); text nesmí být delší než
     *  dnešní věta, jinak najede do fotky vpravo */
    bentoText: (claimPct) => (claimPct ? 'Výprodej skladu až ' + pct(claimPct) + ' a další slevy.' : 'Zlevněné zboží napříč sortimentem.'),
    bentoCta: 'Zobrazit výprodej',
    /** pás pod nadpisem kategorie akční nabídky */
    bandText: 'Zlevněné nářadí, technika do dílny i na zahradu a vybavení domácnosti na jednom místě.',
    /** dlaždice výprodeje skladu (pás akční nabídky a mřížka cizí kategorie) */
    tileBody: 'Zboží skladem za výprodejové ceny.',
    tileCta: 'Zobrazit výprodej',
    /** pás na stránce výprodeje skladu */
    clearanceBand: 'Výprodej skladu je součástí Říjnového výprodeje.',
    clearanceBandLink: 'Všechny zlevněné produkty',
  },
  blackFriday: {
    name: 'Black Friday',
    barStrong: 'BLACK FRIDAY',
    barLead: (claimPct) => (claimPct ? ' · výprodej skladu až ' + pct(claimPct) : ' · právě běží'),
    barCta: 'Zobrazit slevy',
    zoneEyebrow: (claimPct) =>
      claimPct ? 'Výprodej skladu až ' + pct(claimPct) + ' a další slevy' : 'Zlevněné zboží napříč sortimentem',
    zoneCta: 'Zobrazit celý Black Friday',
    bentoText: (claimPct) => (claimPct ? 'Výprodej skladu až ' + pct(claimPct) + ' a další slevy.' : 'Zlevněné zboží napříč sortimentem.'),
    bentoCta: 'Zobrazit slevy',
    bandText: 'Zlevněné nářadí, technika do dílny i na zahradu a vybavení domácnosti na jednom místě.',
    tileBody: 'Zboží skladem za výprodejové ceny.',
    tileCta: 'Zobrazit výprodej',
    clearanceBand: 'Výprodej skladu je součástí Black Friday.',
    clearanceBandLink: 'Všechny zlevněné produkty',
    /** popisek nad cenou u zboží akční nabídky (detail) */
    priceTag: 'Black Friday cena',
    /** pruh úspory v košíku a pokladně: „Black Friday: ušetřili jste 891 Kč" */
    cartSaved: 'Black Friday: ušetřili jste ',
    /** banner pod nákupní kartou u zboží bez slevy (detail) */
    buyBannerTitle: 'Black Friday',
    buyBannerText: (claimPct) =>
      claimPct ? 'Výprodej skladu až ' + pct(claimPct) + ' a stovky dalších zlevněných produktů.' : 'Stovky zlevněných produktů na jednom místě.',
    buyBannerCta: 'Zobrazit slevy',
    /** dlaždice Vánoc ve výprodeji (vlna 2) */
    xmasTitle: (claimPct) => 'Vánoce až ' + pct(claimPct),
    xmasBody: 'Vánoční zboží skladem za výprodejové ceny.',
    xmasCta: 'Zobrazit Vánoce',
  },
};
